import { Timeframe } from './types';
import { getStartOf, subtractFromDate } from '../../utils/dates';
import { RANGE_FILTER_TYPES } from '@silverfort-nodelibs/common/utils/consts';

export const TIMEFRAMES_TO_QUERY_PARAMS: Record<Timeframe, number> = {
    '7': RANGE_FILTER_TYPES.LAST_7_DAYS.value,
    '14': RANGE_FILTER_TYPES.LAST_14_DAYS.value,
    '30': RANGE_FILTER_TYPES.LAST_30_DAYS.value,
    '90': RANGE_FILTER_TYPES.CUSTOM_RANGE.value
};

export const getLogsRangeFilter = (timeframe: Timeframe, maxEndDate?: Date) => {
    const now = new Date();
    const numberOfDays = Number(timeframe);

    if (!maxEndDate) {
        if (timeframe === '90') {
            const now = Date.now() / 1000;
            const ninetyDaysAgo = subtractFromDate(new Date(), numberOfDays, 'days').getTime() / 1000;
            return [TIMEFRAMES_TO_QUERY_PARAMS[timeframe], ninetyDaysAgo, now];
        } else {
            return [TIMEFRAMES_TO_QUERY_PARAMS[timeframe || '30'].toString()];
        }
    }

    const startDate = getStartOf(subtractFromDate(now, numberOfDays, 'days'), 'days');
    const endODate = getStartOf(maxEndDate, 'hours');

    return [RANGE_FILTER_TYPES.CUSTOM_RANGE.value, startDate.getTime() / 1000, endODate.getTime() / 1000];
};
